module.exports = __webpack_public_path__ + "static/this-changes-everything-356a4ec546681c8571857f1556860aff.jpg";